export default "__VITE_ASSET__BdM9L07M__"